import { Referral, REFERRAL_CHANNELS } from "./index";
import type { Action } from "../../actions/types";

export const initialState = {};
type StoreState = Referral | {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (
    action.type === "GET_REFERRAL_SUCCESS" &&
    action.data &&
    !REFERRAL_CHANNELS.includes(action.data.channel)
  ) {
    return { ...state, ...action.response.data };
  }

  return state;
}
